import React, { useRef, useState } from "react";
import OrderDetailsView from "../../stories/components/OrderDetailsView";
import { Form } from "antd";
import { alertMessage } from "../../common/Common";
import OrderdetailsComponent from "../../stories/components/OrderdetailsComponent";
import { saveOrderCall, updateOrderCall, updateOrderDetails_v2 } from "../../api/OrdersApi";
import LosUpdate from "./LosUpdate";
import { renderNotification } from "./OrderTypeIcons";
import _ from "lodash";
import PropTypes from "prop-types";

const ManageDetails = (props) => {
  const { accounts, referencesData, vehicleTypes, form, warehouses, totalOrderDetails, currentPreplan = {},
    updateParentDetails, updatedAccountId, levelOfServices, currentOrder = {}, currentOrg ={} , refreshDetails = () => {},
    history = () => {}, isShipper = false, showActions = true, setOutofPreplan, setIsModified, currentRoute
  } =
    props;
  const { customer_order_details: details } = currentOrder;
  const [viewType, setViewType] = useState("details");
  const [orderDetails, setOrderDetails] = useState({ ...details });
  const [isLoading, setIsLoading] = useState(false);
  const [showLosModal, setShowLosModal] = useState(false);


  const { getFieldDecorator, setFieldsValue } = form;

  const detailsRef = useRef(null);
  const updateOrderDetails = (element, value) => {
    setOrderDetails({
      ...orderDetails,
      [element]: value,
    });
    if(['account_id', 'warehouse_id'].includes(element)){
      updateParentDetails(element, value)
    }
  };
  const handleValidate = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const updatedDetails = detailsRef.current();
        if(
          updatedDetails.warehouse_id !== details.warehouse_id || 
          updatedDetails.account_id !== details.account_id 
        ){
          setShowLosModal(true)
        } else {
          handleSave();
        }
      }
    });
  };

  const handleSave = (losDetails = null) => {
    setIsLoading(true);
    const data = {
      customer_order_params: {
        customer_order_id: details.id,
        warehouse_id: orderDetails.warehouse_id,
        organization_id: currentOrg?.id || '',
        location_id: _.get(currentOrder?.locations, '[0].id', '') || ''
      },
      account_block_params: _.pick(detailsRef.current(), [
        "warehouse_id",
        "account_id",
        "hawb",
        "mawb",
        "vehicle_type",
        "reference_1",
        "reference_2",
        "reference_1_type",
        "reference_2_type",
        "references",
        "special",
        "is_hazardous",
        "priority",
        "wh_storage",
      ]),
    };
    if(losDetails){
      data.account_block_params = {
        ...data.account_block_params,
        account_block_params_changed: {
          warehouse_id: data.account_block_params.warehouse_id,
          account_id: data.account_block_params.account_id,
          locations:  Object.keys(losDetails).map(key => ({
            location_id: key,
            los_code: losDetails[key] || '',
            los_name: _.get(_.find(levelOfServices, { code : losDetails[key]}) , "name") || ''
          }))
        }
      }

    }
    updateOrderDetails_v2(currentOrder.id, data).then((result) => {
      if (result.success) {
        renderNotification(
          `Order ${currentOrder.customer_order_details.customer_order_number} details has been updated`,
          "success"
        );
        // if (currentOrder?.id) {
        //   props.history.push(`/orders/${currentOrder.id}/edit`);
        // }
        setIsLoading(false);
        setShowLosModal(false)
        setViewType('details')
        refreshDetails()
      } else {
        setIsLoading(false);
      }
    });
  };

  const handleUpdateWhStorage = () => {
    const locationData =
      locationsRef.current.map((ref) => ref.current && ref.current()) || [];
    const isMultiDay = isMultiDayOrder(locationData);
    updateOrderDetails("wh_storage", isMultiDay);
  };

  return <div>
    {
      viewType === "details" ? (
        <OrderDetailsView
          updateViewType={(actionType) => {
            setViewType(actionType);
          }}
          details={details}
          account={currentOrder.account || {}}
          history={history}
          showActions={showActions}
          isShipper={isShipper}
          currentRoute={currentRoute}
        />
      ) : (
        <OrderdetailsComponent
          accounts={accounts}
          updateOrderDetails={updateParentDetails}
          referencesData={referencesData}
          vehicleTypes={vehicleTypes}
          getDataRef={detailsRef}
          getFieldDecorator={getFieldDecorator}
          updatedAccountId={updatedAccountId}
          setFieldsValue={setFieldsValue}
          order_label_code={orderDetails.label_code || orderDetails.order_label}
          whStorage={orderDetails.wh_storage}
          showActions={showActions}
          details={details}
          warehouses={warehouses}
          handleValidate={handleValidate}
          onCancel={() => setViewType('details')}
          actionType="view"
          isShipper={isShipper}
          currentPreplan={currentPreplan}
          setOutofPreplan={setOutofPreplan}
          setIsModified={setIsModified}
          currentRoute={currentRoute}
        />
      )
    }
    {
      showLosModal && <LosUpdate 
      openModal={showLosModal} 
      setOpenModal={setShowLosModal} 
      levelOfServices={levelOfServices}
      orderDetails={totalOrderDetails}
      handleSave={handleSave}
      />
    }
  </div>
};

ManageDetails.propTypes = {
  currentPreplan: PropTypes.shape(),
  currentRoute: PropTypes.shape(),
  setOutofPreplan: PropTypes.func,
  setIsModified: PropTypes.func,

  
};
ManageDetails.defaultProps = {
  currentPreplan: {},
  currentRoute: {},
  setOutofPreplan: () => {},
  setIsModified: () => {},
};

export default Form.create()(ManageDetails);
